import React, { Component } from 'react'
import { connect } from 'react-redux'
import { oneOfType, func, node, arrayOf, object, string } from 'prop-types'
import Portal from 'react-portal'
import './PopUp.scss'

import Close from './assets/close.svg'
import Slider from '../Slider/Slider'
import Login from '../Auth/Login'
import Otp from '../Auth/Otp'
import Thanks from '../Auth/Thanks'
import Register from '../Auth/Register'
import { changePopup } from '../../modules/Main'
import getScreenWidth from '../../utils/getScreenWidth'

export const PseudoModal = (props) => {
  const width = getScreenWidth()
  const isDesktop = width >= 768

  return (
    <div>
      <div className='popup__wrapper'>
        { isDesktop ? (<div className='popup__subwrapper'>
          <div className='popup__subwrapper__left'>
            <Slider settings={props.settings}>
              {
                props.sliderContent.map((res, index) => (
                  <div key={[`slider-popup-${index}`]} className='popup__title__box'>
                    <h3>{res.title}</h3>
                    <p>{res.subTitle}</p>
                  </div>),
                )
              }
            </Slider>
          </div>
          <div className='popup__subwrapper__right'>
            {React.cloneElement(
              props.children,
              { closePortal: props.closePortal },
            )}
          </div>
        </div>
        ) : (
          <div className='popup__subwrapper'>
            <div className='popup__subwrapper__right popup__subwrapper__right--full'>
              {React.cloneElement(
                props.children,
                { closePortal: props.closePortal },
              )}
            </div>
          </div>
        )}
        <a onClick={props.closePortal} className='close'><img src={Close} className='img__full' alt='' /></a>
      </div>
      <div onClick={props.closePortal} className='active__overlay__overheader' />
    </div>
  )
}

PseudoModal.propTypes = {
  children: node.isRequired,
  closePortal: func,
  settings: object.isRequired,
  sliderContent: arrayOf(object).isRequired,
}

PseudoModal.defaultProps = {
  closePortal: () => {},
}

class PopUp extends Component {
  static defaultProps = {
    sliderContent: [],
    customClass: '',
  }

  static propTypes = {
    sliderContent: arrayOf(object),
    popupSection: string.isRequired,
    buttonTitle: oneOfType([string, object]).isRequired,
    customClass: string,
    changePopup: func.isRequired,
  }

  openSheets = (dom) => {
    setTimeout(() => {
      dom.getElementsByClassName('active__overlay__overheader')[0].classList.add('animate')
    }, 250)
    setTimeout(() => {
      dom.getElementsByClassName('popup__wrapper')[0].classList.add('animate')
    }, 350)
  }

  closeSheets = (dom, remove) => {
    dom.getElementsByClassName('popup__wrapper')[0].classList.remove('animate')
    setTimeout(() => {
      dom.getElementsByClassName('active__overlay__overheader')[0].classList.remove('animate')
    }, 100)
    setTimeout(() => {
      remove()
      this.props.changePopup('login')
    }, 250)
  }
  render() {
    const { buttonTitle, customClass, popupSection } = this.props
    const openButton = !React.isValidElement(buttonTitle) ?
      (<a className={`menu__link ${customClass}`} >{buttonTitle}</a>) :
      (buttonTitle)
    const settings = {
      dots: true,
      infinite: true,
      speed: 500,
      autoplay: true,
      autoplaySpeed: 3000,
      slidesToShow: 1,
      slidesToScroll: 1,
      centerMode: false,
      draggable: true,
      swipeToSlide: true,
      variableWidth: false,
      arrows: false,
      nextArrow: false,
      prevArrow: false,
      dotsClass: 'slick-dots',
    }

    let sliderContent = []

    if (popupSection === 'login') {
      sliderContent = [{
        title: 'Selamat datang di minapoli',
        subTitle: `Minapoli merupakan platform jaringan
        informasi dan bisnis perikanan terintegrasi.`,
      }, {
        title: 'Daftar dan dapatkan akses ke fitur Minapoli',
        subTitle: `Di Minapoli Anda bisa mengakses berbagai informasi mengenai produk, jasa, informasi serta event-
        event perikanan terkini.`,
      }, {
        title: 'Promosikan perusahaan Anda disini',
        subTitle: `Pastikan produk atau jasa Anda menjangkau target pasar yang tepat. Anda dapat memasarkan dan
        mempromosikan produk, jasa, informasi, dan event perikanan Anda disini.`,
      },
      {
        title: 'Temukan berbagai kebutuhan perikanan',
        subTitle: `Minapoli lebih dari sebuah marketplace, Anda juga bisa mendapatkan informasi dan event perikanan
        yang Anda butuhkan.`,
      }]
    } else if (popupSection === 'register') {
      sliderContent = [{
        title: 'Selamat datang di minapoli',
        subTitle: `Free directories: directories are perfect for customers that
        are searching for a particular topic. What’s great.`,
      }, {
        title: 'Selamat datang di minapoli',
        subTitle: `Free directories: directories are perfect for customers that
        are searching for a particular topic. What’s great.`,
      }, {
        title: 'Selamat datang di minapoli',
        subTitle: `Free directories: directories are perfect for customers that
        are searching for a particular topic. What’s great.`,
      }]
    } else if (popupSection === 'otp') {
      sliderContent = [{
        title: 'Temukan berbagai kebutuhan perikanan',
        subTitle: `Free directories: directories are perfect for customers that
        are searching for a particular topic. What’s great.`,
      }, {
        title: 'Temukan berbagai kebutuhan perikanan',
        subTitle: `Free directories: directories are perfect for customers that
        are searching for a particular topic. What’s great.`,
      }, {
        title: 'Temukan berbagai kebutuhan perikanan',
        subTitle: `Free directories: directories are perfect for customers that
        are searching for a particular topic. What’s great.`,
      }]
    } else if (popupSection === 'thanks') {
      sliderContent = [{
        title: 'Temukan berbagai kebutuhan perikanan',
        subTitle: `Free directories: directories are perfect for customers that
        are searching for a particular topic. What’s great.`,
      }, {
        title: 'Temukan berbagai kebutuhan perikanan',
        subTitle: `Free directories: directories are perfect for customers that
        are searching for a particular topic. What’s great.`,
      }, {
        title: 'Temukan berbagai kebutuhan perikanan',
        subTitle: `Free directories: directories are perfect for customers that
        are searching for a particular topic. What’s great.`,
      }]
    }


    let content = null

    if (popupSection === 'login') {
      content = <Login />
      // content = <Otp />
    } else if (popupSection === 'register') {
      content = <Register />
    } else if (popupSection === 'otp') {
      content = <Otp />
    } else if (popupSection === 'thanks') {
      content = <Thanks />
    }


    return (
      <Portal
        onOpen={dom => this.openSheets(dom)}
        beforeClose={(dom, remove) => this.closeSheets(dom, remove)}
        closeOnEsc
        openByClickOn={openButton}>
        <PseudoModal settings={settings} sliderContent={sliderContent}>
          {content}
        </PseudoModal>
      </Portal>
    )
  }
}

const mapStateToProps = state => ({
  popupSection: state.main.popUp,
})

export default connect(
  mapStateToProps,
  { changePopup },
)(PopUp)




// WEBPACK FOOTER //
// ./src/common/Modals/PopUp.js